import { render } from "./AddQuery.vue?vue&type=template&id=c5ba6e68&scoped=true"
import script from "./AddQuery.vue?vue&type=script&lang=js"
export * from "./AddQuery.vue?vue&type=script&lang=js"

import "./AddQuery.vue?vue&type=style&index=0&id=c5ba6e68&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ba6e68"]])

export default __exports__